import { render, staticRenderFns } from "./SimpleBox.vue?vue&type=template&id=06e09c8c&scoped=true"
import script from "./SimpleBox.vue?vue&type=script&lang=js"
export * from "./SimpleBox.vue?vue&type=script&lang=js"
import style0 from "./SimpleBox.vue?vue&type=style&index=0&id=06e09c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e09c8c",
  null
  
)

export default component.exports